import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "key-backup-field"
}
const _hoisted_2 = {
  class: "key-backup-code-display",
  "aria-label": "Код восстановления"
}
const _hoisted_3 = { class: "key-backup-check" }
const _hoisted_4 = { class: "key-backup-field" }
const _hoisted_5 = {
  key: 0,
  class: "key-backup-error"
}
const _hoisted_6 = { class: "key-backup-field" }
const _hoisted_7 = {
  key: 0,
  class: "key-backup-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    class: "admin-releases-modal key-backup-modal",
    "is-open": _ctx.isOpen,
    "backdrop-dismiss": _ctx.mode === 'create' || _ctx.mode === 'change',
    onDidDismiss: _ctx.onDismiss
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  (_ctx.mode !== 'restore')
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        onClick: _ctx.close
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("Закрыть", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding key-backup-content" }, {
        default: _withCtx(() => [
          ((_ctx.mode === 'create' || _ctx.mode === 'change') && _ctx.step === 'show')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "key-backup-lead" }, " Код нужен, чтобы прочитать историю Liga.Chat на новом телефоне или в другом браузере. Это не пароль входа в Liga.Team. Сервер видит только зашифрованный бекап — не сообщения и не код. ", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "key-backup-warning" }, [
                  _createElementVNode("strong", null, "Запомните или запишите этот код."),
                  _createTextVNode(" Если потеряете — историю Liga.Chat на новом устройстве "),
                  _createElementVNode("strong", null, "не восстановить"),
                  _createTextVNode(". Мы не сможем его сбросить: код есть только у вас. ")
                ], -1)),
                (_ctx.mode === 'change')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", { class: "key-backup-label" }, "Текущий код", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldCode) = $event)),
                        class: "key-backup-input",
                        type: "text",
                        inputmode: "numeric",
                        pattern: "[0-9]{6}",
                        maxlength: "6",
                        autocomplete: "one-time-code",
                        placeholder: "••••••"
                      }, null, 512), [
                        [_vModelText, _ctx.oldCode]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.generatedCode), 1),
                _createElementVNode("label", _hoisted_3, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wroteDown) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.wroteDown]
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "Я записал(а) код в надёжном месте", -1))
                ]),
                _createVNode(_component_ion_button, {
                  class: "messenger-primary-btn",
                  expand: "block",
                  disabled: !_ctx.wroteDown || (_ctx.mode === 'change' && !_ctx.isValidCode(_ctx.oldCode)),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 'confirm'))
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Продолжить ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                (_ctx.mode === 'create')
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 1,
                      class: "messenger-clear-btn",
                      expand: "block",
                      fill: "clear",
                      onClick: _ctx.later
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode(" Настроить позже ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            : ((_ctx.mode === 'create' || _ctx.mode === 'change') && _ctx.step === 'confirm')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "key-backup-warning" }, " Введите код ещё раз, чтобы подтвердить, что вы его записали. Без кода историю на новом устройстве восстановить нельзя. ", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "key-backup-label" }, "Повтор кода", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmCode) = $event)),
                      class: "key-backup-input",
                      type: "text",
                      inputmode: "numeric",
                      pattern: "[0-9]{6}",
                      maxlength: "6",
                      autocomplete: "one-time-code",
                      placeholder: "••••••"
                    }, null, 512), [
                      [_vModelText, _ctx.confirmCode]
                    ])
                  ]),
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_button, {
                    class: "messenger-primary-btn",
                    expand: "block",
                    disabled: _ctx.busy || !_ctx.isValidCode(_ctx.confirmCode),
                    onClick: _ctx.submitCreate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.busy ? 'Сохранение…' : 'Сохранить бекап'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_ion_button, {
                    class: "messenger-clear-btn",
                    expand: "block",
                    fill: "clear",
                    disabled: _ctx.busy,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step = 'show'))
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" Назад ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ], 64))
              : (_ctx.mode === 'restore')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[18] || (_cache[18] = _createElementVNode("p", { class: "key-backup-lead" }, " Введите код восстановления Liga.Chat из 6 цифр, который вы записали. Без него история на этом устройстве останется недоступной. ", -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "key-backup-warning" }, " Неверный код не удалит бекап — можно попробовать снова. Если пропустите восстановление, будет создано новое устройство без старых ключей. ", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "key-backup-label" }, "Код восстановления", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.restoreCode) = $event)),
                        class: "key-backup-input",
                        type: "text",
                        inputmode: "numeric",
                        pattern: "[0-9]{6}",
                        maxlength: "6",
                        autocomplete: "one-time-code",
                        placeholder: "••••••"
                      }, null, 512), [
                        [_vModelText, _ctx.restoreCode]
                      ])
                    ]),
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_button, {
                      class: "messenger-primary-btn",
                      expand: "block",
                      disabled: _ctx.busy || !_ctx.isValidCode(_ctx.restoreCode),
                      onClick: _ctx.submitRestore
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.busy ? 'Восстановление…' : 'Восстановить'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]),
                    _createVNode(_component_ion_button, {
                      class: "messenger-clear-btn",
                      expand: "block",
                      fill: "clear",
                      disabled: _ctx.busy,
                      onClick: _ctx.skipRestore
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode(" Пропустить ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ], 64))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "backdrop-dismiss", "onDidDismiss"]))
}